import React from "react";
import { Box } from "@bca/ui-library";

const EmbeddedMessageTheme: React.FunctionComponent = (props) => {

  return (
    <Box display="flex" justifyContent="center">
      <Box display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        width={{ mobile: "90%", tablet: "490px", desktop: "560px"}}
      >
        {props.children}
      </Box>
    </Box>
  )
}

export default EmbeddedMessageTheme;